import { createRequest, getEndpoint } from "../requestCreator";

export const getGuards = createRequest(getEndpoint("guards.sub.get"));
export const deleteGuard = createRequest(getEndpoint("guards.sub.delete"));
export const createGuard = createRequest(getEndpoint("guards.sub.create"));
export const updateGuard = createRequest(getEndpoint("guards.sub.update"));
